import { SecurityCardProps } from "@/components/screen/global-components/security/SecurityCard";

export const securityConfidentialCards: SecurityCardProps[] = [
  {
    iconId: "icon-encrypted_48",
    title: "Data encryption",
    description:
      "We use state-of-the-art encryption to protect all client data during transmission and storage",
  },
  {
    iconId: "icon-access_48",
    title: "Strict access controls",
    description:
      "Our platform includes secure access controls where only your authorized users, translators, and internal staff with a verified need can access your content.",
  },
  {
    iconId: "icon-global_32",
    title: "HTTPS",
    description:
      "Our platform is secured by HTTPS mechanisms to ensure only authorized personnel can handle or view sensitive information.",
  },
  {
    iconId: "icon-text-shield_32",
    title: "Confidentiality agreements",
    description:
      "All of our employees and translators sign strict NDAs to ensure confidentiality",
  },
  {
    iconId: "icon-folder-lock_32",
    title: "Secure file handling",
    description: "We will remove all of your files upon request at any time.",
  },
  {
    iconId: "icon-user_32",
    title: "Human-first translations",
    description:
      "We do not use AI-generated translations unless explicitly requested by you.",
  },
  {
    iconId: "icon-language_48",
    title: "You own your translation",
    description: "We never claim rights to your content or translated material",
  },
  {
    iconId: "icon-baseline-block_32",
    title: "We never sell or share your data",
    description:
      "Your files and information are never used for training or third-party access.",
  },
  {
    iconId: "icon-edit_32",
    title: "Transparency and control",
    description:
      "You stay in control of your content through Langex dashboard, which lets you track progress in real time, manage access and delivery and request revisions.",
  },

];
